import { render, staticRenderFns } from "./curso-detalle-2.vue?vue&type=template&id=43cb060a&"
import script from "./curso-detalle-2.vue?vue&type=script&lang=js&"
export * from "./curso-detalle-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports